import { generatePath } from 'react-router-dom'
import _ from 'lodash'
import SideBar from '../Common/HorizontalLayout/SideBar'

const getSideBarItems = (routes) => {
  return routes.map(route => {
    const toPath = generatePath(route.path, {
      statsType: route.statsType
    })
    return {
      label: route.text,
      path: toPath,
      key: toPath
    }
  })
}

const SidePane = (props) => {
  const { routes } = props
  const defaultSelected = _.get(props, 'location.pathname', null)
  return (
    <SideBar
      items={getSideBarItems(routes)}
      defaultSelected={defaultSelected}
    />
  )
}

export default SidePane
